import { useBehavior, useCheckBox } from '@libs/hooks';
import { AssetsSvgMap, TInputData, TWidgetProps } from '@libs/types';
import { camelCaseToKebabCase, getFieldName } from '@libs/utils';
import clsx from 'clsx';
import React, { Activity, useId } from 'react';
import { SvgComponent } from '../../common/Svg/SvgComponent';
import { TCheckboxOption } from '../../types/options';
import { getInlineStyles } from '../../utils/styles';
import { TextCommon } from '../UI/Text/TextCommon';
import styles from './checkBoxSwitcher.module.css';

const Checkbox = ({ widget }: TWidgetProps<TInputData, TCheckboxOption>) => {
    const id = useId();
    const data = widget.data ?? {};
    const options = widget.options ?? {};
    const label = data.messages?.label || data.label;
    const { handleChange, isChecked } = useCheckBox(widget);
    const { isDisabled, isHidden } = useBehavior(widget);

    return (
        <Activity mode={isHidden ? 'hidden' : 'visible'}>
            <div data-test={widget.uid} style={getInlineStyles({ margin: options.margin })}>
                <label className={clsx(styles.checkboxLabel, isDisabled && styles.disabled)} htmlFor={id}>
                    <input
                        data-test={`input_${widget.uid}`}
                        className={styles.checkboxInput}
                        id={id}
                        name={getFieldName(options.autofill)}
                        autoComplete={camelCaseToKebabCase(options.autofill)}
                        type="checkbox"
                        onChange={handleChange}
                        checked={isChecked}
                        disabled={isDisabled}
                        tabIndex={data.tabIndex}
                    />
                    <span className={styles.checkboxIndicator}>
                        <span className={styles.checkboxTickWrap}>
                            <SvgComponent width={20} height={20} fill="white_base" name={AssetsSvgMap.ic_check_20} />
                        </span>
                    </span>
                    {label && (
                        <TextCommon
                            isWidget={false}
                            content={label}
                            options={{
                                textColor: isDisabled ? 'grey_16_lc' : 'grey_72_lc',
                                margin: { left: 16 },
                            }}
                        />
                    )}
                </label>
            </div>
        </Activity>
    );
};
export { Checkbox };
